import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { BookOpen, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.roles?.includes('Admin') || user.roles?.includes('Editor')) navigate('/panel');
      else if (user.roles?.includes('Revisor')) navigate('/panel/mis-revisiones');
      else navigate('/panel/mis-manuscritos');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesion');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="text-center mb-8">
          <div className="w-10 h-10 rounded-sm bg-slate-dark flex items-center justify-center mx-auto mb-4">
            <BookOpen className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-serif font-bold text-slate-dark">Iniciar Sesion</h1>
          <p className="text-sm font-sans text-gray-400 mt-1">Accede a tu cuenta de Archivos Trans</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
          {error && <div className="p-3 text-sm font-sans bg-red-50 text-red-600 rounded-md border border-red-100" data-testid="login-error">{error}</div>}
          
          <div className="space-y-1.5">
            <Label htmlFor="email" className="font-sans text-sm">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="tu@email.com" data-testid="login-email" className="font-sans" />
          </div>

          <div className="space-y-1.5">
            <div className="flex items-center justify-between">
              <Label htmlFor="password" className="font-sans text-sm">Contrasena</Label>
              <Link to="/recuperar-contrasena" className="text-xs font-sans text-trans-blue hover:underline" data-testid="forgot-password-link">Olvidaste tu contrasena?</Link>
            </div>
            <div className="relative">
              <Input id="password" type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required placeholder="Tu contrasena" data-testid="login-password" className="font-sans pr-10" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <Button type="submit" className="w-full bg-slate-dark hover:bg-slate-dark/90 font-sans" disabled={loading} data-testid="login-submit-btn">
            {loading ? 'Ingresando...' : 'Iniciar Sesion'}
          </Button>
        </form>

        <p className="text-center text-sm font-sans text-gray-400 mt-6">
          No tienes cuenta?{' '}
          <Link to="/registro" className="text-trans-blue hover:underline font-medium" data-testid="login-register-link">Registrate aqui</Link>
        </p>
      </div>
    </div>
  );
}
